/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorEditConversationsEditNewScorecardAttributeRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.edit.conversations.edit.new-scorecard.attribute',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorEditConversationsEditNewScorecardAttributeRoute);
